import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { host } from "../../config/Config";

export const NewHaircut = () => {
  const { id } = useParams();
  const [haircut, setHaircut] = React.useState(null);
  const [newHaircut, setNewHaircut] = React.useState("");
  const [newPrice, setNewPrice] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState(null);
  const navigate = useNavigate();


  const handleSaveChanges = async () => {
    if (newPrice.trim().length === 0 || newHaircut.trim().length === 0) {
        return;
    }
    try {
      const token = localStorage.getItem("jwt-vlada");
      const response = await fetch(`${host}/api/v1/haircuts`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: newHaircut,
          price: parseInt(newPrice, 10)
        })
      });

      if (!response.ok) {
        throw new Error(`Error updating haircut: ${response.status}`);
      }

      setSuccessMessage(true); // Show success message after update


      setTimeout(() => {
        setSuccessMessage(null);
        setNewHaircut("")
        setNewPrice("")
      }, 2000);
    } catch (error) {
      console.error("Error saving haircut details:", error);
      setSuccessMessage(false);

      setTimeout(() => {
        setSuccessMessage(null);
        setNewHaircut("")
        setNewPrice("")
      }, 2000);
    }
  };

  const handlePocetna = () => {
    navigate("/admin");
  };


  return (
    <div className="barber-zajednica-admin-page">
      <div className="barber-zajednica-admin-background"></div>

      <h2 style={{marginTop: "60px", color:"#737373"}}>Naziv nove usluge</h2>
      <input
        style={{marginTop: "20px", width: "80%", textAlign:"center", padding: "0"}}
        type="text"
        value={newHaircut} // Now using state
        className="barber-zajednica-input-password"
        onChange={(e) => setNewHaircut(e.target.value)} // Update state
      />

      <h2 style={{marginTop: "50px", color: "#737373"}}>Cena usluge</h2>
      <input
        style={{width: "25%", textAlign:"center", padding: "0"}}
        type="number"
        value={newPrice} // Now using state
        className="barber-zajednica-input-password"
        onChange={(e) => setNewPrice(e.target.value)} // Update state
      />

      {successMessage && <h3 style={{marginTop: "60px", marginBottom:"-30px"}}>Uspešno sačuvano</h3>}
      {successMessage === false && <h3 style={{marginTop: "60px", marginBottom:"-30px"}}>Došlo je do greške</h3>}

      <button 
        onClick={handleSaveChanges}
        className="barber-zajednica-login-button-user" 
        style={{marginTop: "70px"}}
      >
        Dodaj uslugu
      </button>

      <button 
        onClick={handlePocetna}
        className="barber-zajednica-login-button-user"  
        style={{ marginTop: "30px", marginBottom: "0px", zIndex: "1000" }}>
        Nazad na Profil
      </button>
    </div>
  );
};
